<mat-card class="cur-card">
  <mat-card-header>
    <mat-card-title>検索結果</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div class="table-responsive" style="max-height: 500px;">
      <table mat-table [dataSource]="dataSource" matSort [style.min-width]="minWidth" #sort1="matSort">
        <ng-container matColumnDef="select">
          <th mat-header-cell class="border-bottom-double text-center" style="width: 1em;" *matHeaderCellDef>
            <mat-checkbox (change)="$event ? isAllSelected ? onClickAllClear() : onClickAllCheck() : null;"
              [checked]="selection.hasValue() && isAllSelected" [indeterminate]="selection.hasValue() && !isAllSelected"
              [aria-label]="checkboxLabel()" color="primary">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="text-center">
            <mat-checkbox color="primary" (change)="$event ? selection.toggle(row) : null;"
              [checked]="selection.isSelected(row)" (click)="$event?.stopPropagation()">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="servicerconsignmenttargetCodevalue">
          <th mat-header-cell class="border-bottom-double text-center" style="min-width: 75px;" *matHeaderCellDef>
            サービサー<br>委託対象
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-select autocomplete="off" [(ngModel)]="row.servicerconsignmenttargetCodevalue"
              [ngModelOptions]="{standalone: true}" class="disabled-select-color" (click)="$event?.stopPropagation()">
              <mat-option></mat-option>
              <mat-option *ngFor="let div of servicerConsignmentTargetList"
                [value]="div.value">{{div.viewValue}}</mat-option>
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="consignmenttoCodevalue">
          <th mat-header-cell class="border-bottom-double text-center" style="min-width: 130px;" *matHeaderCellDef>
            委託先
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-select autocomplete="off" [(ngModel)]="row.consignmenttoCodevalue"
              [ngModelOptions]="{standalone: true}" class="disabled-select-color" (click)="$event?.stopPropagation()">
              <mat-option *ngFor="let div of consignmentList" [value]="div.value">{{div.viewValue}}</mat-option>
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="companyAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 130px;" *matHeaderCellDef>
            会社
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.companyAname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="pressInchargeregionAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 45px;" *matHeaderCellDef>地区
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.pressInchargeregionAname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="pressmanagementdivisionAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 90px;" *matHeaderCellDef>
            督促管理区分</th>
          <td mat-cell *matCellDef="let row">
            {{ row.pressmanagementdivisionAname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="servicerconsignmentStsAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 140px;" *matHeaderCellDef>
            サービサー委託<br>ステータス</th>
          <td mat-cell *matCellDef="let row">
            {{ row.servicerconsignmentStsAname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="payCtrNo">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 120px;" *matHeaderCellDef>
            支払契約番号</th>
          <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
        </ng-container>
        <ng-container matColumnDef="visitName">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 85px;" *matHeaderCellDef>
            請求先名</th>
          <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
        </ng-container>
        <ng-container matColumnDef="visitornumber">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 90px;" *matHeaderCellDef>
            お客さま番号</th>
          <td mat-cell *matCellDef="let row">{{ row.visitornumber }}</td>
        </ng-container>
        <ng-container matColumnDef="consignMny">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 105px;" *matHeaderCellDef>
            委託金額[円]</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.consignMny| number }}</td>
        </ng-container>
        <ng-container matColumnDef="consignScdMny">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 115px;" *matHeaderCellDef>
            委託予定金額[円]</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.consignScdMny| number }}</td>
        </ng-container>
        <ng-container matColumnDef="supplystopTerminationdate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 80px;" *matHeaderCellDef>
            利用停止日</th>
          <td mat-cell *matCellDef="let row">{{ row.supplystopTerminationdate | dateString }}</td>
        </ng-container>
        <ng-container matColumnDef="breakReasonAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 120px;" *matHeaderCellDef>
            利用停止理由</th>
          <td mat-cell *matCellDef="let row">
            {{ row.breakReasonAname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="preConsignmentto">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 130px;" *matHeaderCellDef>
            前回委託先</th>
          <td mat-cell *matCellDef="let row">
            {{ row.preConsignmentto }}
          </td>
        </ng-container>
        <ng-container matColumnDef="consignStartdate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 80px;" *matHeaderCellDef>
            委託開始日</th>
          <td mat-cell *matCellDef="let row">{{ row.consignStartdate | dateString }}</td>
        </ng-container>
        <ng-container matColumnDef="consignStpDate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 80px;" *matHeaderCellDef>
            委託停止日</th>
          <td mat-cell *matCellDef="let row">{{
            row.consignStpDate | dateString }}</td>
        </ng-container>
        <ng-container matColumnDef="consignmentsuspensionReasonAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 90px;" *matHeaderCellDef>
            委託停止理由</th>
          <td mat-cell *matCellDef="let row">
            {{ row.consignmentsuspensionReasonAname }}
          </td>
        </ng-container>
        <ng-container matColumnDef="receivableTotalmoney">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 105px;" *matHeaderCellDef>
            未入金額[円]</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.receivableTotalmoney| number }}</td>
        </ng-container>

        <ng-container matColumnDef="transferdestinationTyosayohiCodevalue">
          <th mat-header-cell class="border-bottom-double text-center" style="min-width: 120px;" *matHeaderCellDef>
            移転先調査要否
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-select autocomplete="off" [(ngModel)]="row.transferdestinationTyosayohiCodevalue"
              [ngModelOptions]="{standalone: true}" class="disabled-select-color" (click)="$event?.stopPropagation()"
              [disabled]="!isEnableCell('transferdestinationTyosayohiCodevalue', row)"
              *ngIf="isEnableCell('transferdestinationTyosayohiCodevalue', row)">
              <mat-option></mat-option>
              <mat-option *ngFor="let div of transferDestinationTyosayohiList"
                [value]="div.value">{{div.viewValue}}</mat-option>
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="servicerRecommissiontargetCodevalue">
          <th mat-header-cell class="border-bottom-double text-center" style="min-width: 60px;" *matHeaderCellDef>
            サービサー<br>再委託対象
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-select autocomplete="off" [(ngModel)]="row.servicerRecommissiontargetCodevalue"
              [ngModelOptions]="{standalone: true}" class="disabled-select-color" (click)="$event?.stopPropagation()"
              (selectionChange)="onChangeRecnsgnJudgeList(row)"
              [disabled]="!isEnableCell('servicerRecommissiontargetCodevalue', row)"
              *ngIf="isEnableCell('servicerRecommissiontargetCodevalue', row)">
              <mat-option></mat-option>
              <mat-option *ngFor="let div of serviceRecommissionTargetList"
                [value]="div.value">{{div.viewValue}}</mat-option>
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="recommissiontargetTargetgairsnCodevalue">
          <th mat-header-cell class="border-bottom-double text-center" style="min-width: 100px;" *matHeaderCellDef>
            再委託対象外理由
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-select autocomplete="off" [(ngModel)]="row.recommissiontargetTargetgairsnCodevalue"
              [ngModelOptions]="{standalone: true}" class="disabled-select-color" (click)="$event?.stopPropagation()"
              [disabled]="!isEnableCell('recommissiontargetTargetgairsnCodevalue', row)"
              *ngIf="isEnableCell('recommissiontargetTargetgairsnCodevalue', row)">
              <mat-option></mat-option>
              <mat-option *ngFor="let div of recommissionTargetTargetgaiRsnList" [value]="div.value">{{ div.viewValue
                }}</mat-option>
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="gas">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 45px;" *matHeaderCellDef>ガス
          </th>
          <td mat-cell style="text-align: center;" *matCellDef="let row">{{ row.gas }}</td>
        </ng-container>
        <ng-container matColumnDef="elec">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 45px;" *matHeaderCellDef>電気
          </th>
          <td mat-cell style="text-align: center;" *matCellDef="let row">{{ row.elec }}</td>
        </ng-container>
        <ng-container matColumnDef="message">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 280px;" *matHeaderCellDef>
            メッセージ</th>
          <td mat-cell *matCellDef="let row">{{ row.message }}</td>
        </ng-container>
        <ng-container matColumnDef="chargedivisionAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" style="min-width: 7em;" *matHeaderCellDef>
            料金区分</th>
          <td mat-cell *matCellDef="let row">
            {{ row.chargedivisionAname }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsCol" class="clickable-mat-row"
          (dblclick)="onDblClickRow(row, $event)"></tr>
      </table>
    </div>

    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center"
      style="display:flex;">
      <mat-card-actions class="btn_area_right">
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickTargetRegist()"
          [disabled]="disableTargetResist()" *ngIf="task != MODE_UPDATE">登録</button>
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRelocationResearchResist()"
          [disabled]="disableRelocationResearchResist()" *ngIf="task == MODE_UPDATE">移転先調査要否登録</button>
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRecnsgnResist()"
          [disabled]="disableRecnsgnResist()" *ngIf="task == MODE_UPDATE">再委託登録</button>
      </mat-card-actions>
    </div>
  </mat-card-content>
</mat-card>